import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const Buttons: React.FC = () => {
	return (
		<Button type="submit" data-qa="report-abuse-submit-button">
			<Translate value="fe.components.petition_report_abuse.form_submit" />
		</Button>
	);
};
